import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { discountsApi } from '../api/discounts-api';

import { discountKeys } from './discount-keys';

export const USAGES_LIMIT = 10;

export function useDiscountUsages(storeId: string, id: string, cursor: string | undefined) {
  return useQuery({
    queryKey: discountKeys.usages(storeId, id, cursor),
    queryFn: () =>
      discountsApi.usages(storeId, id, { limit: USAGES_LIMIT, ...(cursor ? { cursor } : {}) }),
    placeholderData: keepPreviousData,
  });
}
